import React, {useEffect, useState} from 'react';
import {FiCalendar, FiChevronRight, FiHome} from "react-icons/fi";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {CustomDropdownFilterObject} from "../ressources/CustomComponents";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import cx from "classnames";
import {FaFileExport} from "react-icons/fa";
import * as XLSX from "xlsx";
import {getAllOperators} from "../services/technicalService";
import {getAllPartners} from "../services/partnerService";
import {getServicesRevenue} from "../services/serviceManagementServices";
import DataTable from "react-data-table-component";

function PartnerRevenue(props) {

  const {t} = useTranslation();

  const [isOperatorSelectOpen, setIsOperatorSelectOpen] = useState(false);
  const [operator, setOperator] = useState({});
  const [operatorList, setOperatorList] = useState([]);
  const [isPartnerSelectOpen, setIsPartnerSelectOpen] = useState(false);
  const [partner, setPartner] = useState({});
  const [partnerList, setPartnerList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [revenueData, setRevenueData] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectOperator = (operator) => {
    setOperator(operator);
    setIsOperatorSelectOpen(false);
  }

  const selectPartner = (val)=>{
    setPartner(val);
    setIsPartnerSelectOpen(false);
  }

  function exportToExcel(tableData, fileName) {
    const ws = XLSX.utils.json_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  const fetchOperators = async () => {
    await getAllOperators()
      .then((res)=> setOperatorList(res.results) )
      .catch((err)=>console.log(err));
  }

  const fetchPartners = async () => {
    await getAllPartners()
      .then((res)=> {
        setPartnerList(res.results);
      })
      .catch((err)=>console.log(err));
  }

  const fetchRevenue = async () =>{
    setLoading(true);
    await getServicesRevenue(operator.operatorId, (partner.partnerId || 0), moment(startDate).format('MM/DD/YYYY'), moment(endDate).format('MM/DD/YYYY'))
      .then((res)=> {
        console.log(res.results);
        setRevenueData(res.results);
      })
      .catch((err)=>console.log(err))
      .finally(()=>{
        setLoading(false);
      })
  }

  useEffect(()=>{
    fetchOperators();
    fetchPartners();
  }, []);

  useEffect(() => {
    if(Object.keys(operator).length > 0 && startDate !== null && endDate !== null ){
      fetchRevenue();
    }
  }, [operator, startDate, endDate, partner]);


  const columns = [
    {
      name: 'Date',
      selector: row => moment(row.dated).format("DD/MM/YYYY"),
      sortable: true,
    },
    {
      name: 'Operator Name',
      selector: row => row.operatorName,
      sortable: true,
    },
    {
      name: 'Service Name',
      selector: row => row.serviceName,
      sortable: true,
    },
    {
      name: 'Short Code',
      selector: row => row.shortCode,
      sortable: true,
    },
    {
      name: 'New Subscription',
      selector: row => row.newSubscription,
      sortable: true,
    },
    {
      name: 'Unsubscription',
      selector: row => row.unSubscription,
      sortable: true,
    },
    {
      name: 'Hits',
      selector: row => row.hits,
      sortable: true,
    },
    {
      name: 'Total Sub Count',
      selector: row => row.totalSubCount,
      sortable: true,
    },
    {
      name: 'Total Revenue',
      selector: row => row.totalRevenue,
      sortable: true,
    },
  ];

  return (
    <div>
      <div>
        <div className="text-gray-500 flex items-center gap-2 mt-2 mb-6">
          <span className="text-xs font-semibold flex items-center">
            <FiHome size={12}/> <FiChevronRight size={12}/>
          </span>
          <h4 className="text-xs font-semibold text-gray-500">{t("PARTNER_REVENUE.TITLE")}</h4>
        </div>
        <div className="flex items-center justify-between mb-6">
          {/*<div className="w-1/3 text-start">*/}
          {/*  <h1 className="text-xl font-bold">{t("PARTNER_REVENUE.TITLE")}</h1>*/}
          {/*</div>*/}
          <div className="grid grid-cols-6 items-center gap-4 w-full">
            <div className="w-full col-span-3">
              <CustomDropdownFilterObject
                label="Operators"
                isOpen={isOperatorSelectOpen}
                setIsOpen={setIsOperatorSelectOpen}
                itemList={[{operatorId: 0, operatorName: "See all"}, ...operatorList]}
                selectedItem={operator}
                itemKey="operatorName"
                idKey="operatorId"
                selectItem={selectOperator}
              />
            </div>
            <div className="w-full col-span-3">
              <CustomDropdownFilterObject
                label="Partners"
                isOpen={isPartnerSelectOpen}
                setIsOpen={setIsPartnerSelectOpen}
                itemList={partnerList}
                selectedItem={partner}
                itemKey="partnerName"
                idKey="partnerId"
                selectItem={selectPartner}
                disabled={Object.keys(operator).length === 0}
              />
            </div>
            <div className="border rounded-lg px-2 py-1.5 text-sm flex items-center gap-2 bg-white w-full col-span-2">
              <FiCalendar className="text-gray-400"/>
              <DatePicker
                selected={startDate}
                onChange={(e) => setStartDate(e)}
                type="text"
                dateFormat="dd/MM/yyyy"
                placeholderText='Date'
                isClearable
                disabled={Object.keys(operator).length === 0}
                wrapperClassName="w-full"
                className="w-full"
              />
            </div>
            <div className="border rounded-lg px-2 py-1.5 text-sm flex items-center gap-2 bg-white w-full col-span-2">
              <FiCalendar className="text-gray-400"/>
              <DatePicker
                selected={endDate}
                onChange={(e) => setEndDate(e)}
                type="text"
                dateFormat="dd/MM/yyyy"
                placeholderText='Date'
                isClearable
                disabled={Object.keys(operator).length === 0}
                wrapperClassName="w-full"
                className="w-full"
              />
            </div>
            <button
              onClick={() => exportToExcel(revenueData, `revenue-from-${moment(startDate).format('MM/DD/YYYY')}-to-${moment(endDate).format('MM/DD/YYYY')}`)}
              disabled={revenueData.length <= 0}
              className={cx("bg-azure flex items-center gap-4 col-span-2 px-4 py-1.5 text-sm font-semibold rounded-lg text-white hover:opacity-60 hover:shadow", {
                'bg-azure': revenueData.length > 0,
                'bg-gray-400': revenueData.length <= 0,
              })}
            >
              <FaFileExport size={18}/>
              <span>Export file</span>
            </button>
          </div>
        </div>
      </div>
      {
        loading
          ?
          <div className='bg-white p-0 rounded-lg mt-4 shadow overflow-x-auto'>
            Loading...
          </div>
          :
          <div className='bg-white p-0 rounded-lg mt-4 shadow overflow-x-auto relative z-0'>
            <DataTable
              columns={columns}
              data={revenueData}
              customStyles={{
                headCells: {
                  style: {
                    backgroundColor: '#f3f4f6',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    fontSize: '12px',
                  },
                },
                cells: {
                  style: {
                    padding: '16px',
                    textAlign: 'left',
                  },
                },
              }}
              highlightOnHover
              pagination
            />
          </div>
      }
    </div>
  );
}

export default PartnerRevenue;
